import { render } from "./YaMetrika.vue?vue&type=template&id=61883786"
import script from "./YaMetrika.vue?vue&type=script&lang=js"
export * from "./YaMetrika.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__